import utils from '@/common/util/utils'
import {
  IS_PRODUCTION_MODE,
  URL_COOKIE_DOMAIN,
  SERVICE_LOCATION_KEY,
  API_BASE_URL,
  PAYMENT_GATE_TYPE_ONE_STORE,
  PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE,
  PRODUCT_TYPE_PRODUCT,
  MOBILE_WEB_HOSTNAME,
  PC_WEB_HOSTNAME,
} from '@/common/constant'
import { stringify, parseUrl } from 'query-string'
import { isNil, get, replace } from 'lodash'
import { knock } from '@/common/api/api.service'
import { EventBus } from '@/components/eventbus/EventBus'
import { getEventListByType } from '@/common/util/event.util'
import { ON_CLICK } from '@/common/event.const'
import router from '@/router'
import store from '@/store'
import { SET_CURRENT_MENU } from '@/store/types/mutations.type'
import { FETCH_MULTI_BANNER_LIST_INFO } from '@/store/types/actions.type'
import {
  PATH_NAME_LIST,
  DISABLE_BOTTOM_TAB_ROUTE_NAME_LIST,
  PATH_NAME_INSTANTPLAY_LIST,
} from '@/common/router.const'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
import { navigateViewMoreCatalog } from '@/common/util/view-more/navigate-view-more-catalog'
import { isCatalogViewMore } from '@/common/util/view-more/is-catalog-view-more'

export const getTypeCodeFromTitleString = (title) => {
  switch (title) {
    case '프로그램':
      return 'program'
    case 'VOD':
      return 'vod'
    case 'LIVE':
      return 'live'
    case '영화':
      return 'movie'
    case 'TV컷':
      return 'clip'
    case '에디터Pick':
      return 'theme'
    case '고객지원':
      return 'faq'
    case '영화플러스':
      return 'movie'
  }
}
const getCookieExpireDate = () => {
  const expires = new Date()
  expires.setHours(0, 0, 0, 0)
  expires.setDate(expires.getDate() + 365)
  return expires
}
const getOneYearExpireUTCString = () => getCookieExpireDate().toUTCString()
const isSaveUserID = (saveId) => !isNil(saveId) && saveId
export const saveIdProcess = ({ saveId = false, userId }) => {
  if (isSaveUserID(saveId)) {
    utils.cookies.setItem(
      'userId',
      userId,
      getOneYearExpireUTCString(),
      URL_COOKIE_DOMAIN,
      '/',
    )
  } else {
    utils.cookies.removeItem('userId', URL_COOKIE_DOMAIN, '/')
  }
}
export const isPreRenderer = () => {
  return get(window, ['__PRERENDER_INJECTED', 'isPreRender'], '') === 'y'
}
export const setAutoLoginInfo = ({ autoLogin, credential }) => {
  if (autoLogin) {
    utils.cookies.setAutoLoginCredential(credential)
  }
}
const hasProtocol = (url) => url.substring(0, 4) === 'http'
const prependProtocol = (url) => location.protocol + '//' + url

export const bannerLink = (targetUrl) => {
  if (targetUrl.indexOf('captvpooq://purchasewebview') > -1) {
    const { query } = parseUrl(targetUrl)
    let cancelUrl = window.location.origin + '/callback.html?action=Cancel'
    utils.common.showBillingPopup({
      productId: query.productId,
      productType: 'all',
      returnUrl: 'https://m.wavve.com',
      canceledUrl: cancelUrl,
    })
  } else if (targetUrl.substring(0, 9) === 'captvpooq') {
    utils.common.checkInstallApps(targetUrl.replace('captvpooq://', ''))
  } else {
    const { url, query } = parseUrl(targetUrl)
    const hasWavveDomain = url.indexOf('wavve.com') > -1
    let newUrl = hasProtocol(url) ? url : prependProtocol(url)
    if (hasWavveDomain) {
      if (url.indexOf('member.wavve.com') > -1) {
        newUrl = newUrl.replace('http://', 'https://')
      }
      newUrl = newUrl.replace('www.wavve.com', 'm.wavve.com')
      if (IS_PRODUCTION_MODE) {
        location.href = newUrl + '?' + stringify(query)
      } else {
        location.href =
          newUrl.replace('m.wavve.com', location.host) + '?' + stringify(query)
      }
    } else {
      if (IS_PRODUCTION_MODE) {
        location.href = newUrl + '?' + stringify(query)
      } else {
        location.href =
          newUrl.replace('m.wavve.com', location.host) + '?' + stringify(query)
      }
    }
  }
}
export const removePrefixEmptyString = (string) => {
  const res = []
  const charList = string.split('')
  let removeComplete = false
  for (let i = 0, len = charList.length; i < len; i++) {
    if (charList[i] !== ' ') {
      removeComplete = true
    }
    if (removeComplete) {
      res.push(charList[i])
    }
  }
  return res.join('')
}
export const androidPurchase = ({
  productId,
  url,
  contentId = '',
  contentType = '',
}) => {
  window.Android.clickPurchase(productId, url, contentId, contentType)
}
export const androidPromotionPurchase = ({
  productId,
  promotionCode,
  url,
  contentId = '',
  contentType = '',
}) => {
  window.Android.clickPurchase(
    productId,
    promotionCode,
    url,
    contentId,
    contentType,
  )
}
export const androidOneStorePurchase = ({
  productId,
  url,
  contentId = '',
  contentType = '',
  pgName,
}) => {
  // export const androidOneStorePurchase = (params) => {
  window.Android.clickOneStorePurchase(
    productId,
    url,
    contentId,
    contentType,
    pgName,
  )
}
export const androidGoogleStorePurchase = ({
  productId,
  productTypeForGoogleIAP,
}) => {
  console.log('androidGoogleStorePurchase : productId : ' + productId)
  console.log(
    'androidGoogleStorePurchase : prodcutType : ' + productTypeForGoogleIAP,
  )
  window.Android.clickGooglePurchase(productTypeForGoogleIAP, productId)
}

export const voucherPurchase = ({
  deviceType,
  productId,
  contentType = '',
  contentId = '',
  promotionCode = '',
  callbackAction = 'ClosePopupAndReload',
  canceledCallbackAction = 'Cancel',
  pgName = '',
  productTypeForGoogleIAP = '',
  callbackParams = {},
}) => {
  const returnUrl = utils.queryString.concatParams(
    window.location.origin + '/callback.html?action=' + callbackAction,
    callbackParams,
  )
  const canceledUrl = utils.queryString.concatParams(
    window.location.origin + '/callback.html?action=' + canceledCallbackAction,
  )
  try {
    if (deviceType === DEVICE_TYPE_IOS) {
      window.webkit.messageHandlers.clickPurchase.postMessage(productId)
    } else if (deviceType === DEVICE_TYPE_ANDROID) {
      const url = encodeURIComponent(returnUrl)
      if (pgName === PAYMENT_GATE_TYPE_ONE_STORE) {
        androidOneStorePurchase({
          productId,
          url,
          contentId,
          contentType,
          pgName,
        })
      } else if (pgName === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE) {
        if (productTypeForGoogleIAP === PRODUCT_TYPE_PRODUCT) {
          androidPurchase({ productId, url, contentId, contentType })
        } else {
          androidGoogleStorePurchase({ productTypeForGoogleIAP, productId })
        }
      } else {
        if (promotionCode === '') {
          androidPurchase({ productId, url, contentId, contentType })
        } else {
          androidPromotionPurchase({
            productId,
            url,
            contentId,
            contentType,
            promotionCode,
          })
        }
      }
    } else {
      utils.common.showBillingPopup({
        productId,
        productType: 'all',
        returnUrl,
        contentType,
        contentId,
        promotionCode,
        canceledUrl,
      })
    }
  } catch (err) {
    console.log(err)
  }
}

export function comparePath(orgPath, checkPath) {
  let isCorrect = false
  if (orgPath === checkPath) return true
  const orgPathList = orgPath.split('/')
  const checkPathList = checkPath.split('/')
  if (orgPathList.length === checkPathList.length) {
    let isMatched = true
    let i = 0
    while (i < checkPathList.length) {
      if (!isMatched) break
      const orgPath = orgPathList[i]
      const checkPath = checkPathList[i]
      if (orgPath !== '{path}') {
        isMatched = orgPath === checkPath
      }
      i = i + 1
    }
    isCorrect = isMatched
  }
  return isCorrect
}

export function hasUserConfirmPPV() {
  return utils.cookies.isPpvConfirmUser()
}

export function getTitle(cell) {
  let title = ''
  get(cell, 'title_list', []).forEach((titleItem) => {
    title += ' ' + titleItem.text
  })
  return title
}
export const replaceUrl = (url) => {
  url = url.replace('https://', '')
  url = url.replace('http://', '')
  url = url.replace(PC_WEB_HOSTNAME, '')
  url = url.replace(MOBILE_WEB_HOSTNAME, '')
  url = url.replace('.html', '')
  return url
}
export function selectCell(cell) {
  const { onNavigationEvent, onClickEvent } = getEventListByType(
    get(cell, 'event_list', []),
  )
  if (onClickEvent) {
    EventBus.$emit(ON_CLICK, onClickEvent)
  }
  const { url, query } = parseUrl(
    get(onNavigationEvent, 'url', '').replace('.html', ''),
  )
  let newQuery = query
  let referer = location.pathname

  if (referer.indexOf('search') > -1) {
    referer = referer + '?' + location.search
  }

  if (referer.match(/category\/main/gi)) {
    referer = `${location.pathname}?${location.search}`
  }

  newQuery.referer = referer
  let newUrl = replaceUrl(url)
  router.push(newUrl + '?' + stringify(newQuery))
}

export function WavveOnProfileImageInfo() {
  const wavveonType = utils.cookies.getPooqZoneType()
  switch (wavveonType) {
    case 'pcbang':
      return { image: 'ic-my-profile-pc.png', imageAlt: '피시방' }
    case 'library':
      return { image: 'ic-my-profile-library.png', imageAlt: '도서관' }
    case 'hospital':
      return { image: 'ic-my-profile-hospital.png', imageAlt: '병원' }
    case 'accommodations':
      return { image: 'ic-my-profile-stay.png', imageAlt: '숙박업소' }
    default:
      return { image: 'ic-my-profile-others.png', imageAlt: '그외 기타' }
  }
}

export function hasViewMore(sectionInfo) {
  return get(sectionInfo, 'viewMoreEvent', null) !== null
}

export function sectionInfoTitle(sectionInfo) {
  return get(sectionInfo, 'title', '')
}

export function viewMoreTitle(sectionInfo) {
  return get(sectionInfo, 'viewMoreEvent.title', '더보기')
}
const isApiUrl = (viewMoreUrl) => {
  let { url } = parseUrl(viewMoreUrl)
  url = url.replace('http://', '').replace('https://', '')
  const targetUrl = url.indexOf('/') > -1 ? url.split('/')[0] : url
  return API_BASE_URL.replace('https://', '').indexOf(targetUrl) > -1
}
const getUiCode = (viewMoreEvent, route) => {
  const { url, query } = parseUrl(viewMoreEvent.url)
  const uiCode = get(query, 'uitype', '')
  const hasUiCode = uiCode !== ''
  if (hasUiCode) {
    return uiCode
  } else {
    const uiParent = get(query, 'uiparent', '')
    const hasUiParent = uiParent !== ''
    if (hasUiParent) {
      return uiParent.indexOf('-') > -1
        ? uiParent.split('-').pop()
        : url.split('/').pop()
    } else {
      return url.split('/').pop()
    }
  }
}
const getCustomQuery = (onViewMore, route) => {
  return {
    api: encodeURIComponent(
      get(onViewMore, 'url', '').replace('https://', '').replace('http://', ''),
    ),
    referer: get(route, 'fullPath', ''),
    came: get(route, 'name', ''),
  }
}
export function routeToList(sectionInfo, route) {
  const isInstantPlay =
    get(sectionInfo, 'viewMoreEvent.url', '').indexOf('/instantplay/') > -1

  const onViewMore = get(sectionInfo, 'viewMoreEvent', {})

  if (isCatalogViewMore(onViewMore.url)) {
    return router.push(navigateViewMoreCatalog(onViewMore?.url))
  }

  if (isApiUrl(get(sectionInfo, 'viewMoreEvent.url', ''))) {
    router.push({
      name: isInstantPlay ? PATH_NAME_INSTANTPLAY_LIST : PATH_NAME_LIST,
      params: {
        section: get(route, 'name', ''),
        url: get(sectionInfo, 'viewMoreEvent.url', ''),
        uiCode: getUiCode(get(sectionInfo, 'viewMoreEvent', {}), route),
      },
      query: getCustomQuery(get(sectionInfo, 'viewMoreEvent', {}), route),
    })
  } else {
    // TODO: 서버에 요청하여 새로운 규격 처리 해달라고 해야됨
    const { url, query } = parseUrl(get(sectionInfo, 'viewMoreEvent.url', ''))
    const newUrl = replaceUrl(url)

    if (!query?.referer) {
      query.referer = route.fullPath
    }

    router.push(`${newUrl}?${stringify(query)}`).catch(() => {})
  }
}
export function isEnableBottomTabView(routeName) {
  return DISABLE_BOTTOM_TAB_ROUTE_NAME_LIST.indexOf(routeName) === -1
}
export function sendKnock() {
  const KNOCK_TRACE_KEY = 'knock_trace_key'
  const isMobileWeb = utils.cookies.getDevice() === 'mobile'
  if (isMobileWeb && utils.cookies.getItem(KNOCK_TRACE_KEY) !== 'knock') {
    knock().then(() => {
      utils.cookies.setItem(KNOCK_TRACE_KEY, 'knock')
    })
  }
}
let debounce
export function mainBeforeEnter(to, from, next) {
  if (to.path.indexOf('index.html') > -1) {
    next(to.path.replace('/index.html', ''))
  }
  store.commit(SET_CURRENT_MENU, to.name)
  next()
  if (to.name === 'home') return
  store
    .dispatch(FETCH_MULTI_BANNER_LIST_INFO, { menuName: to.name })
    .then(() => {})
  if (debounce) {
    clearTimeout(debounce)
  }
}
export const isApp = () => {
  const appList = [DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS]
  return appList.indexOf(utils.cookies.getDevice()) !== -1
}

/**
 * dev 도메인 여부
 * @returns {boolean}
 */
export const isDev = () => {
  const origin = location.origin
  return origin.indexOf('dev-') > -1 || origin.indexOf('localhost') > -1
}

/**
 * qa 도메인 여부
 * @returns {boolean}
 */
export const isQA = () => {
  const origin = location.origin
  return origin.indexOf('qa-') > -1
}
/**
 * api, 플레이어 호출등에서 현재 도메인 dev, qa에 따라 프리픽스 붙이는 함수
 * @param domain 프로토콜이 꼭 붙어있어야 함 (http, https)
 * @returns {string}
 */
export const getDomainWithPrefix = (domain) => {
  if (!domain || typeof domain !== 'string') {
    return ''
  }
  if (isDev()) {
    return domain.replace(/(https?:\/\/)/, '$1dev-')
  }
  if (isQA()) {
    return domain.replace(/(https?:\/\/)/, '$1qa-')
  }
  return domain
}
export const getGUID = () =>
  get(JSON.parse(localStorage.getItem('guid')), 'guid', '')

export const setGUID = (guid) => {
  localStorage.setItem('guid', JSON.stringify(guid))
}
export const setIp = (ip) => {
  localStorage.setItem('ip', ip)
}
export const replaceSpecialCharacters = (string) => {
  // eslint-disable-next-line
  const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi
  return replace(string, regExp, '') // ?
}
export const getTimeStamp = () => {
  let date = new Date()
  let requestTime = ''
  requestTime += date.getFullYear() + '-'
  requestTime += ('00' + (date.getMonth() + 1)).slice(-2) + '-'
  requestTime += ('00' + date.getDate()).slice(-2) + ' '
  requestTime += ('00' + date.getHours()).slice(-2) + ':'
  requestTime += ('00' + date.getMinutes()).slice(-2) + ':'
  requestTime += ('00' + date.getSeconds()).slice(-2)
  return requestTime + '+900'
}
export const getDomainWithWordPrefix = (str, domain) => {
  if (!domain || typeof domain !== 'string') {
    return ''
  }
  return domain.replace(/(https?:\/\/)/, `$1${str}-`)
}

/**
 * object의 nullish property를 제거합니다.
 * @param {object} origin
 * @returns {object} nullish property가 제거된 object
 */
export const removeNullishProperty = (origin) => {
  const result = {}
  if (origin) {
    for (let key in origin) {
      if (origin[key] !== null && origin[key] !== undefined) {
        result[key] = origin[key]
      }
    }
  }
  return result
}

/**
 * 배포된 환경에 대한 정보를 반환합니다.
 *
 * - `release` 브랜치, `stg` 브랜치: `prd`
 * - `qa` 브랜치: `qa`
 * - `dev` 브랜치, 그 외(로컬 환경 등): `dev`
 *
 * @returns {string} 환경 정보 (`dev` | `qa` | `prd`)
 */
export const getEnv = () => {
  const env = process.env.VUE_APP_COMMIT_BRANCH
  switch (env) {
    case 'release':
    case 'stg':
      return 'prd'
    case 'qa':
      return 'qa'
    default:
      return 'dev'
  }
}
